import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Play-Box"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-play-box',
    templateUrl: './icon-play-box.component.html',
    styleUrls: ['./icon-play-box.component.scss'],
    standalone: false
})
export class IconPlayBoxComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
